import styled from 'styled-components'

export const TitleWrapper = styled.div`
  .title-main {
    font-size: 1.5rem;
    color: var(--vbdt-color-text-primary);
    font-family: inherit;
    position: relative;
    font-weight: 700;
  }

  /* .title-main::after {
    content: "";
    width: 80px;
    height: 4px;
    background-image: -webkit-linear-gradient(
      0deg,
      rgb(21, 67, 152) 0%,
      rgb(238, 29, 35) 100%
    );
    position: absolute;
    left: 40px;
    bottom: -2px;
    margin: 0 0 0 -40px;
  } */
`
